import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImgFallbackDirective } from '@banyan/commons/directives/src-fallback.directive';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import {
  HorizontalStepCardComponent,
} from '@banyan/modules/standalone/horizontal-step-card/horizontal-step-card.component';
import { TranslateModule } from '@ngx-translate/core';

export interface Expertise {
  title: string;
  description: string;
  icon: string;
  text_link: string;
  url: string;
}

@Component({
  selector: 'app-home-expertise-section',
  templateUrl: './home-expertise-section.component.html',
  styleUrls: ['./home-expertise-section.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    GradientComponent,
    TranslateModule,
    HorizontalStepCardComponent,
    ImgFallbackDirective,
  ],
})
export class HomeExpertiseSectionComponent {
  @Input() title: string = '';
  @Input() image: string = '';
  @Input() expertise_1: Expertise = {
    title: '',
    icon: '',
    url: '',
    description: '',
    text_link: ''
  };
  @Input() expertise_2: Expertise = {
    title: '',
    icon: '',
    url: '',
    description: '',
    text_link: ''
  };
  @Input() expertise_3: Expertise = {
    title: '',
    icon: '',
    url: '',
    description: '',
    text_link: ''
  };
}
